dmx.Component('f7-range', {

  initialData: {
    value: null
  },

  attributes: {
    value: {
      type: Number,
      default: null, // defaults to center
    },

    min: {
      type: Number,
      default: 0,
    },

    max: {
      type: Number,
      default: 100,
    },

    step: {
      type: Number,
      default: 1,
    },

    label: {
      type: Boolean,
      default: false,
    },

    dragableBar: {
      type: Boolean,
      default: true,
    },

    noDraggableBar: { // for backwards compatibility
      type: Boolean,
      default: false,
    },

    vertical: {
      type: Boolean,
      default: false,
    },

    verticalReversed: {
      type: Boolean,
      default: false,
    },

    scale: {
      type: Boolean,
      default: false,
    },

    scaleSteps: {
      type: Number,
      default: 5,
    },

    scaleSubSteps: {
      type: Number,
      default: 0,
    },

    params: {
      type: Object,
      default: {},
    },
  },

  methods: {
    setValue (value) {
      if (!this._component) return;
      this._component.setValue(value);
    },
  },

  events: {
    change: Event,
    changed: Event,
  },

  render (node) {
    dmx.f7.ready(app => {
      const range = this._component = app.range.create({
        value: this.props.value,
        min: this.props.min,
        max: this.props.max,
        step: this.props.step,
        label: this.props.label,
        draggableBar: this.props.noDraggableBar ? false : this.props.draggableBar,
        vertical: this.props.vertical,
        verticalReversed: this.props.verticalReversed,
        scale: this.props.scale,
        scaleSteps: this.props.scaleSteps,
        scaleSubSteps: this.props.scaleSubSteps,
        ...this.props.params,
        el: node,
      });

      range.on('change', (range, value) => {
        this.set('value', value);
        this.dispatchEvent('change');
      });

      range.on('changed', () => this.dispatchEvent('changed'));

      this.set('value', range.value);
    });
  },

  performUpdate (updatedProps) {
    if (this._component) {
      if (updatedProps.has('value')) {
        this._component.setValue(this.props.value);
      }
    }
  },

  destroy () {
    if (this._component) {
      this._component.destroy();
      delete this._component;
    }
  },
  
});